import {
  CHANGE_ASSIGNEES_ASYNC,
  CLOSE_INCIDENT_ASYNC,
  CLOSE_SAFE_CHALLENGE_INCIDENT_ASYNC,
  DOWNLOAD_ORIGINAL_EMAIL_ASYNC,
  EMAIL_SNAPSHOT_ASYNC,
  FETCH_AFFECTED_MAILBOXES_COUNTS_ASYNC,
  FETCH_ASSIGNEES_ASYNC,
  FETCH_COMMUNITY_INSIGHTS_ASYNC,
  FETCH_MSFT_QUARANTINE_REPORT_ASYNC,
  FETCH_PAGINATED_REPORTERS_ASYNC,
  FETCH_REPORT_ELEMENTS_ASYNC,
  FETCH_SCANS_FREEMIUM_LIMIT_ASYNC,
  KEEP_ENCRYPTED_INCIDENT_IN_QUARANTINE_ASYNC,
  OPEN_EMAIL_SNAPSHOT_NEW_TAB,
  RELEASE_ENCRYPTED_INCIDENT_ASYNC,
  RELEASE_MSFT_QUARANTINE_REPORT_ASYNC,
  REPORT_ELEMENTS_REQUEST_ASYNC,
  REPORT_ELEMENTS_UPDATE_ASYNC,
  REPORT_REQUEST_ASYNC,
  REPORT_STATE_CHANGE_ASYNC,
  REQUEST_THEMIS_GENERATE_ASYNC,
  SET_ESCALATED_EMAIL_CARD_TAB_KEY,
  SHOW_AFFECTED_MAILBOXES_VIEW,
  SHOW_SCANNER_DETAILS_VIEW,
  THEMIS_ANALYSIS_ASYNC,
  THEMIS_ANALYSIS_PARTIAL_UPDATE,
  UPDATE_MSFT_QUARANTINE_ASSIGNEE_ASYNC,
  VALIDATE_NEW_AFFECTED_MAILBOXES_SEEN_ASYNC,
} from './constants'

export const fetchReport = (reportId, reportType, { background = false } = {}) => ({
  type: REPORT_REQUEST_ASYNC.INITIATE,
  payload: { reportId, reportType, background },
})
export const fetchReportSuccess = (data) => ({
  type: REPORT_REQUEST_ASYNC.SUCCESS,
  payload: { data },
})
export const fetchReportError = (error) => ({
  type: REPORT_REQUEST_ASYNC.ERROR,
  error,
})
export const fetchReportCancel = () => ({ type: REPORT_REQUEST_ASYNC.CANCEL })

export const fetchCommunityInsights = (reportId) => ({
  type: FETCH_COMMUNITY_INSIGHTS_ASYNC.INITIATE,
  payload: { reportId },
})
export const fetchCommunityInsightsSuccess = (data) => ({
  type: FETCH_COMMUNITY_INSIGHTS_ASYNC.SUCCESS,
  payload: { data },
})
export const fetchCommunityInsightsError = (error) => ({
  type: FETCH_COMMUNITY_INSIGHTS_ASYNC.ERROR,
  error,
})
export const fetchCommunityInsightsCancel = () => ({
  type: FETCH_COMMUNITY_INSIGHTS_ASYNC.CANCEL,
})

export const changeReportState = (reportId, reportType, newState) => ({
  type: REPORT_STATE_CHANGE_ASYNC.INITIATE,
  payload: { reportId, reportType, newState },
})
const changeReportStateCancel = () => ({
  type: REPORT_STATE_CHANGE_ASYNC.CANCEL,
})
export const changeReportStateSuccess = (data, newState, reportType, reportId) => ({
  type: REPORT_STATE_CHANGE_ASYNC.SUCCESS,
  payload: { data, newState, reportType, reportId },
})
export const changeReportStateError = (error) => ({
  type: REPORT_STATE_CHANGE_ASYNC.ERROR,
  error,
})

const updateElements = (reportId, reportType, elementsName) => ({
  type: REPORT_ELEMENTS_UPDATE_ASYNC.INITIATE,
  payload: { reportId, reportType, elementsName },
})
const updateElementsCancel = () => ({
  type: REPORT_ELEMENTS_UPDATE_ASYNC.CANCEL,
})
export const updateElementsSuccess = (data) => ({
  type: REPORT_ELEMENTS_UPDATE_ASYNC.SUCCESS,
  payload: { data },
})
export const updateElementsError = (error) => ({
  type: REPORT_ELEMENTS_UPDATE_ASYNC.ERROR,
  error,
})

const fetchElements = (reportId, reportType, elementsName) => ({
  type: REPORT_ELEMENTS_REQUEST_ASYNC.INITIATE,
  payload: { reportId, reportType, elementsName },
})
const fetchElementsCancel = () => ({
  type: REPORT_ELEMENTS_REQUEST_ASYNC.CANCEL,
})
export const fetchElementsSuccess = (data, reportId, elementsName) => ({
  type: REPORT_ELEMENTS_REQUEST_ASYNC.SUCCESS,
  payload: { data, reportId, elementsName },
})
export const fetchElementsError = (error) => ({
  type: REPORT_ELEMENTS_REQUEST_ASYNC.ERROR,
  error,
})

export const fetchReportElements = (reportId, body, reportType) => ({
  type: FETCH_REPORT_ELEMENTS_ASYNC.INITIATE,
  payload: { reportId, body, reportType },
})
export const fetchReportElementsSuccess = (data, otype, page) => ({
  type: FETCH_REPORT_ELEMENTS_ASYNC.SUCCESS,
  payload: { data, otype, page },
})
export const fetchReportElementsError = (error) => ({
  type: FETCH_REPORT_ELEMENTS_ASYNC.ERROR,
  error,
})
export const fetchReportElementsCancel = () => ({ type: FETCH_REPORT_ELEMENTS_ASYNC.CANCEL })

export const fetchPaginatedReporters = (reportId, page) => ({
  type: FETCH_PAGINATED_REPORTERS_ASYNC.INITIATE,
  payload: { reportId, page },
})
export const fetchPaginatedReportersSuccess = (data) => ({
  type: FETCH_PAGINATED_REPORTERS_ASYNC.SUCCESS,
  payload: { data },
})
export const fetchPaginatedReportersError = (error) => ({
  type: FETCH_PAGINATED_REPORTERS_ASYNC.ERROR,
  error,
})

export const fetchReportReportersCancel = () => ({ type: FETCH_PAGINATED_REPORTERS_ASYNC.CANCEL })

const validateNewAffectedMailboxesSeen = () => ({
  type: VALIDATE_NEW_AFFECTED_MAILBOXES_SEEN_ASYNC.INITIATE,
})
export const validateNewAffectedMailboxesSeenSuccess = () => ({
  type: VALIDATE_NEW_AFFECTED_MAILBOXES_SEEN_ASYNC.SUCCESS,
})
export const validateNewAffectedMailboxesSeenError = (error) => ({
  type: VALIDATE_NEW_AFFECTED_MAILBOXES_SEEN_ASYNC.ERROR,
  error,
})

const fetchAffMailboxesCounts = (reportId) => ({
  type: FETCH_AFFECTED_MAILBOXES_COUNTS_ASYNC.INITIATE,
  payload: { reportId },
})
export const fetchAffMailboxesCountsSuccess = (data) => ({
  type: FETCH_AFFECTED_MAILBOXES_COUNTS_ASYNC.SUCCESS,
  payload: { data },
})
export const fetchAffMailboxesCountsError = (error) => ({
  type: FETCH_AFFECTED_MAILBOXES_COUNTS_ASYNC.ERROR,
  error,
})

export const fetchAssignees = (search) => ({
  type: FETCH_ASSIGNEES_ASYNC.INITIATE,
  payload: { search },
})
export const fetchAssigneesSuccess = (data) => ({
  type: FETCH_ASSIGNEES_ASYNC.SUCCESS,
  payload: { data },
})
export const fetchAssigneesError = (error) => ({
  type: FETCH_ASSIGNEES_ASYNC.ERROR,
  error,
})
export const fetchAssigneesCancel = (error) => ({
  type: FETCH_ASSIGNEES_ASYNC.CANCEL,
  error,
})

export const changeAssignees = (reportId, reportType, assigneeId) => ({
  type: CHANGE_ASSIGNEES_ASYNC.INITIATE,
  payload: { reportId, reportType, assigneeId },
})
export const changeAssigneesSuccess = (data) => ({
  type: CHANGE_ASSIGNEES_ASYNC.SUCCESS,
  payload: { data },
})
export const changeAssigneesError = (error) => ({
  type: CHANGE_ASSIGNEES_ASYNC.ERROR,
  error,
})
export const changeAssigneesCancel = (error) => ({
  type: CHANGE_ASSIGNEES_ASYNC.CANCEL,
  error,
})

const fetchScansFreemiumLimit = () => ({
  type: FETCH_SCANS_FREEMIUM_LIMIT_ASYNC.INITIATE,
})
export const fetchScansFreemiumLimitSuccess = (data) => ({
  type: FETCH_SCANS_FREEMIUM_LIMIT_ASYNC.SUCCESS,
  payload: { data },
})
export const fetchScansFreemiumLimitError = (error) => ({
  type: FETCH_SCANS_FREEMIUM_LIMIT_ASYNC.ERROR,
  error,
})

const downloadOriginalEmail = (reportId, emailType) => ({
  type: DOWNLOAD_ORIGINAL_EMAIL_ASYNC.INITIATE,
  payload: { reportId, emailType },
})
export const downloadOriginalEmailSuccess = (data) => ({
  type: DOWNLOAD_ORIGINAL_EMAIL_ASYNC.SUCCESS,
  payload: { data },
})
export const downloadOriginalEmailError = (error, id) => ({
  type: DOWNLOAD_ORIGINAL_EMAIL_ASYNC.ERROR,
  payload: {
    error,
    id,
  },
})

export const showScannerDetailsView = (data) => ({
  type: SHOW_SCANNER_DETAILS_VIEW,
  payload: { data },
})
export const showAffMailboxesView = (data) => ({
  type: SHOW_AFFECTED_MAILBOXES_VIEW,
  payload: { data },
})

const closeIncident = (reportId) => ({
  type: CLOSE_INCIDENT_ASYNC.INITIATE,
  payload: { reportId },
})
export const closeIncidentSuccess = (data) => ({
  type: CLOSE_INCIDENT_ASYNC.SUCCESS,
  payload: { data },
})
export const closeIncidentError = (error) => ({
  type: CLOSE_INCIDENT_ASYNC.ERROR,
  error,
})

const closeSafeChallengeIncident = (reportId) => ({
  type: CLOSE_SAFE_CHALLENGE_INCIDENT_ASYNC.INITIATE,
  payload: { reportId },
})
export const closeSafeChallengeSuccess = (data) => ({
  type: CLOSE_SAFE_CHALLENGE_INCIDENT_ASYNC.SUCCESS,
  payload: { data },
})
export const closeSafeChallengeError = (error) => ({
  type: CLOSE_SAFE_CHALLENGE_INCIDENT_ASYNC.ERROR,
  error,
})

const releaseEncryptedIncident = (reportId) => ({
  type: RELEASE_ENCRYPTED_INCIDENT_ASYNC.INITIATE,
  payload: { reportId },
})
export const releaseEncryptedIncidentSuccess = (data) => ({
  type: RELEASE_ENCRYPTED_INCIDENT_ASYNC.SUCCESS,
  payload: { data },
})
export const releaseEncryptedIncidentError = (error) => ({
  type: RELEASE_ENCRYPTED_INCIDENT_ASYNC.ERROR,
  error,
})

const keepEncryptedIncidentInQuarantine = (reportId) => ({
  type: KEEP_ENCRYPTED_INCIDENT_IN_QUARANTINE_ASYNC.INITIATE,
  payload: { reportId },
})
export const keepEncryptedIncidentInQuarantineSuccess = (data) => ({
  type: KEEP_ENCRYPTED_INCIDENT_IN_QUARANTINE_ASYNC.SUCCESS,
  payload: { data },
})
export const keepEncryptedIncidentInQuarantineError = (error) => ({
  type: KEEP_ENCRYPTED_INCIDENT_IN_QUARANTINE_ASYNC.ERROR,
  error,
})

const fetchMSFTQuarantineReport = (reportId) => ({
  type: FETCH_MSFT_QUARANTINE_REPORT_ASYNC.INITIATE,
  payload: { reportId },
})
export const fetchMSFTQuarantineReportSuccess = (data) => ({
  type: FETCH_MSFT_QUARANTINE_REPORT_ASYNC.SUCCESS,
  payload: { data },
})
export const fetchMSFTQuarantineReportError = (error) => ({
  type: FETCH_MSFT_QUARANTINE_REPORT_ASYNC.ERROR,
  error,
})

const releaseMSFTQuarantineReport = (reportId, action) => ({
  type: RELEASE_MSFT_QUARANTINE_REPORT_ASYNC.INITIATE,
  payload: { reportId, action },
})
export const releaseMSFTQuarantineReportSuccess = (data) => ({
  type: RELEASE_MSFT_QUARANTINE_REPORT_ASYNC.SUCCESS,
  payload: { data },
})
export const releaseMSFTQuarantineReportError = (error) => ({
  type: RELEASE_MSFT_QUARANTINE_REPORT_ASYNC.ERROR,
  error,
})

const updateMSFTQuarantineAssignee = (reportId, assigneeId) => ({
  type: UPDATE_MSFT_QUARANTINE_ASSIGNEE_ASYNC.INITIATE,
  payload: { reportId, assigneeId },
})
export const updateMSFTQuarantineAssigneeSuccess = (data) => ({
  type: UPDATE_MSFT_QUARANTINE_ASSIGNEE_ASYNC.SUCCESS,
  payload: { data },
})
export const updateMSFTQuarantineAssigneeError = (error) => ({
  type: UPDATE_MSFT_QUARANTINE_ASSIGNEE_ASYNC.ERROR,
  error,
})

const fetchEmailSnapshot = (reportId) => ({
  type: EMAIL_SNAPSHOT_ASYNC.INITIATE,
  payload: { reportId },
})
export const fetchEmailSnapshotSuccess = (data) => ({
  type: EMAIL_SNAPSHOT_ASYNC.SUCCESS,
  payload: data.emailBodyPreviewUrl,
})
export const fetchEmailSnapshotError = (error) => ({
  type: EMAIL_SNAPSHOT_ASYNC.ERROR,
  error,
})

const openEmailSnapshot = (reportId) => ({
  type: OPEN_EMAIL_SNAPSHOT_NEW_TAB,
  payload: { reportId },
})

const setEscalatedEmailCardTabKey = (key) => ({
  type: SET_ESCALATED_EMAIL_CARD_TAB_KEY,
  payload: { key },
})

export const startThemisAnalysis = (reportId, { manual = false, reportType } = {}) => ({
  type: THEMIS_ANALYSIS_ASYNC.INITIATE,
  payload: { reportId, manual, reportType },
})
export const abortThemisAnalysis = (reportId) => ({
  type: THEMIS_ANALYSIS_ASYNC.CANCEL,
  payload: { reportId },
})
export const themisAnalysisSuccess = (reportId) => ({
  type: THEMIS_ANALYSIS_ASYNC.SUCCESS,
  payload: { reportId },
})
export const themisAnalysisFailure = (reportId, error) => ({
  type: THEMIS_ANALYSIS_ASYNC.ERROR,
  payload: { reportId },
  error,
})
export const themisAnalysisPartialUpdate = (reportId, patch) => ({
  type: THEMIS_ANALYSIS_PARTIAL_UPDATE,
  payload: { reportId, patch },
})
// Records an explicit user request to generate the deep investigation. Gates the
// auto-start effects so credits are spent only on a current user action (IC-49715).
// Consumed in the reducer at THEMIS_ANALYSIS_ASYNC.INITIATE (the spend event).
export const requestThemisGenerate = (reportId) => REQUEST_THEMIS_GENERATE_ASYNC.initiate(reportId)

export default {
  // to props
  fetchReport,
  fetchAssignees,
  changeAssignees,
  fetchReportCancel,
  changeReportState,
  fetchCommunityInsights,
  fetchCommunityInsightsCancel,
  changeReportStateCancel,
  updateElements,
  updateElementsCancel,
  fetchElements,
  fetchElementsCancel,
  fetchReportElements,
  fetchReportElementsCancel,
  fetchReportReportersCancel,
  fetchPaginatedReporters,
  showScannerDetailsView,
  showAffMailboxesView,
  validateNewAffectedMailboxesSeen,
  fetchAffMailboxesCounts,
  fetchScansFreemiumLimit,
  downloadOriginalEmail,
  closeIncident,
  closeSafeChallengeIncident,
  releaseEncryptedIncident,
  keepEncryptedIncidentInQuarantine,
  fetchMSFTQuarantineReport,
  releaseMSFTQuarantineReport,
  updateMSFTQuarantineAssignee,
  fetchEmailSnapshot,
  openEmailSnapshot,
  setEscalatedEmailCardTabKey,
  startThemisAnalysis,
  abortThemisAnalysis,
  themisAnalysisSuccess,
  themisAnalysisFailure,
  themisAnalysisPartialUpdate,
  requestThemisGenerate,
}
